import _regeneratorRuntime from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { connectAudioParam } from '../helpers/connect-audio-param';
import { getNativeAudioNode } from '../helpers/get-native-audio-node';
import { isOwnedByContext } from '../helpers/is-owned-by-context';
import { renderAutomation } from '../helpers/render-automation';
import { renderInputsOfAudioNode } from '../helpers/render-inputs-of-audio-node';
export var createDynamicsCompressorNodeRendererFactory = function createDynamicsCompressorNodeRendererFactory(createNativeDynamicsCompressorNode) {
  return function () {
    var nativeDynamicsCompressorNodePromise = null;

    var createDynamicsCompressorNodes =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(proxy, nativeOfflineAudioContext) {
        var nativeDynamicsCompressorNode, options;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                nativeDynamicsCompressorNode = getNativeAudioNode(proxy);
                /*
                 * If the initially used nativeDynamicsCompressorNode was not constructed on the same OfflineAudioContext it needs to be
                 * created again.
                 */

                if (isOwnedByContext(nativeDynamicsCompressorNode, nativeOfflineAudioContext)) {
                  _context.next = 16;
                  break;
                }

                options = {
                  attack: nativeDynamicsCompressorNode.attack.value,
                  channelCount: nativeDynamicsCompressorNode.channelCount,
                  channelCountMode: nativeDynamicsCompressorNode.channelCountMode,
                  channelInterpretation: nativeDynamicsCompressorNode.channelInterpretation,
                  knee: nativeDynamicsCompressorNode.knee.value,
                  ratio: nativeDynamicsCompressorNode.ratio.value,
                  release: nativeDynamicsCompressorNode.release.value,
                  threshold: nativeDynamicsCompressorNode.threshold.value
                };
                nativeDynamicsCompressorNode = createNativeDynamicsCompressorNode(nativeOfflineAudioContext, options);
                _context.next = 6;
                return renderAutomation(proxy.context, nativeOfflineAudioContext, proxy.attack, nativeDynamicsCompressorNode.attack);

              case 6:
                _context.next = 8;
                return renderAutomation(proxy.context, nativeOfflineAudioContext, proxy.knee, nativeDynamicsCompressorNode.knee);

              case 8:
                _context.next = 10;
                return renderAutomation(proxy.context, nativeOfflineAudioContext, proxy.ratio, nativeDynamicsCompressorNode.ratio);

              case 10:
                _context.next = 12;
                return renderAutomation(proxy.context, nativeOfflineAudioContext, proxy.release, nativeDynamicsCompressorNode.release);

              case 12:
                _context.next = 14;
                return renderAutomation(proxy.context, nativeOfflineAudioContext, proxy.threshold, nativeDynamicsCompressorNode.threshold);

              case 14:
                _context.next = 26;
                break;

              case 16:
                _context.next = 18;
                return connectAudioParam(proxy.context, nativeOfflineAudioContext, proxy.attack);

              case 18:
                _context.next = 20;
                return connectAudioParam(proxy.context, nativeOfflineAudioContext, proxy.knee);

              case 20:
                _context.next = 22;
                return connectAudioParam(proxy.context, nativeOfflineAudioContext, proxy.ratio);

              case 22:
                _context.next = 24;
                return connectAudioParam(proxy.context, nativeOfflineAudioContext, proxy.release);

              case 24:
                _context.next = 26;
                return connectAudioParam(proxy.context, nativeOfflineAudioContext, proxy.threshold);

              case 26:
                _context.next = 28;
                return renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeDynamicsCompressorNode);

              case 28:
                return _context.abrupt("return", nativeDynamicsCompressorNode);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function createDynamicsCompressorNodes(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    return {
      render: function render(proxy, nativeOfflineAudioContext) {
        if (nativeDynamicsCompressorNodePromise === null) {
          nativeDynamicsCompressorNodePromise = createDynamicsCompressorNodes(proxy, nativeOfflineAudioContext);
        }

        return nativeDynamicsCompressorNodePromise;
      }
    };
  };
};